/** Shared SafeVault marketing tokens (aligned with website-safevault). */
export const SAFEVAULT_BRAND = {
  deepPurple: "#3432C7",
  primary: "#061BB0",
  accentPink: "#E91E8C",
  accentInteractive: "#3432C7",
  accentPurple: "#9B59B6",
  textDark: "#1f1f1f",
  textMuted: "#4C5270",
  textNavy: "#061BB0",
  lightGray: "#EDF0F2",
  footerPartnerBg: "#f4f6fc",
  footerBorder: "#dce3f0",
  blogCardImageBg: "#eef1f8",
  pageBg: "#FCFCFC",
  white: "#ffffff",
  gradientPartner: "linear-gradient(90deg, #3432C7 0%, #E91E8C 100%)",
  gradientHero: "linear-gradient(135deg, #3432C7 0%, #061BB0 45%, rgba(233, 30, 140, 0.35) 100%)",
  maxContent: 1280,
  contactEmail: "support-safevault@amitasoft.com",
  contactPhone: "+1 408-430-3650",
  siteName: "SafeVault",
  blogTitle: "SafeVault Blogs",
  blogTagline: "Your Guide to Secure Document Management",
};
